import {
    Grid,
    Hidden,
    Link,
    List,
    ListItem,
    ListItemText,
    makeStyles,
    Typography,
} from '@material-ui/core';
import Project from 'components/Project';
import React from 'react';
import gazeusLogo from '../assets/cover-letter/gazeus.png';
import legoBrick from '../assets/cover-letter/lego-brick.png';
import ustwoLogo from '../assets/cover-letter/ustwo-games.svg';
import me from '../assets/me.jpg';
import '../views/CoverLetter.scss';

const useStyles = makeStyles((theme) => ({
    textAlignCenter: {
        textAlign: 'center',
    },
    iframe: {
        width: '100%',
        height: 400,
        border: 0,
    },
    ppt: {
        [theme.breakpoints.down('sm')]: {
            height: 400,
        },
    },
}));

const CoverLetter = () => {
    const classes = useStyles();

    const criticalTasks = [
        `Created new Enemies + AI's`,
        `Created new Spells for Players and Enemies`,
        `Fixed the Procedural Map Generator`,
        `New Cosmetic DLC packs`,
        `Lots of Bug Fixing`,
    ];

    const hypercasualsVideos = [
        {
            title: 'Spin and Shoot',
            src: 'https://drive.google.com/file/d/1dndC8JzH0xa-zhe1z6vSX0IBOlxW1d_g/preview',
        },
        {
            title: 'Zero Gravity 3D',
            src: 'https://drive.google.com/file/d/1tUkjc0F8CvmseiJVvLbYd51PgTtYneJS/preview',
        },
        {
            title: 'Caterpillar',
            src: 'https://drive.google.com/file/d/1M5m-IQdbNdO1zxM0vNMcWkTx3_HgdYP_/preview',
        },
        {
            title: 'Ball Dive',
            src: 'https://drive.google.com/file/d/1O9Uy9yc4ada3yBKdKqK29nKLupNZS4Wb/preview',
        },
        {
            title: 'Boat Runner 3D',
            src: 'https://drive.google.com/file/d/19-KaeVvOoQVchCQIIzMXnmeeIXobZhSI/preview',
        },
    ];

    const usTwoReasons = [
        `I’m really interested on all areas of Game Development beyond programming;`,
        `I’m always exploring new game mechanics / hooks and creating lores;`,
        `I like to draw, to model in 3D and animate. I also have lots of experience with UI / UX from my web development history;`,
        `I really like to be the bridge between artists / game designers and Unity, searching ways to improve their workflow when creating content;`,
        `I'm always experimenting with new technologies, tools and techniques while joining game jams;`,
    ];

    return (
        <div id='cover-letter'>
            <Project>
                <Grid item xs={12} sm={6}>
                    <Typography variant='h1' component='h1'>
                        Hey, I'm Diego Machado
                    </Typography>
                    <Typography
                        variant='h2'
                        component='h2'
                        style={{
                            margin: '10px 0px',
                            textAlign: 'left',
                            fontSize: '1.5rem',
                        }}
                    >
                        I'm a Jack of All Trades
                    </Typography>
                    <Typography>
                        A 34 years old brazilian game developer and self-taught
                        designer.
                    </Typography>
                </Grid>
                <Grid item xs={12} sm={6} id='me'>
                    <img src={me} alt="It's me!" />
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    direction='column'
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} id='create-stuff'>
                        <Hidden xsDown>
                            <img src={legoBrick} alt='Lego Brick' />
                        </Hidden>
                        <Typography variant='h2' component='h2'>
                            I like to create Stuff
                        </Typography>
                        <Hidden xsDown>
                            <img src={legoBrick} alt='Lego Brick' />
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <Typography className='lead'>
                            As a kid I loved lots of stuff. Lego's, drawing,
                            video games and computers had a special place in my
                            heart.
                        </Typography>

                        <Typography>
                            I decided to become a Computer Scientist because it
                            would allow me to create, from start to finish,
                            anything I can imagine in any electronic device,
                            kinda like I used to do while playing with my Legos
                            or diving into new worlds while playing video games.
                        </Typography>
                    </Grid>
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                    id='critical-studio'
                >
                    <Grid item xs={12}>
                        <Typography variant='h2' component='h2'>
                            Critical Studio Awesomeness
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <iframe
                            title='dungeoland-trailer'
                            width='100%'
                            height='400'
                            src='https://www.youtube.com/embed/yxM9N1xOBqQ'
                            frameBorder='0'
                            allowFullScreen
                        ></iframe>
                    </Grid>
                    <Grid item xs={12} lg={10}>
                        <Typography gutterBottom>
                            I was one of the developers of one of the biggest
                            brazilian indie game studios, named Critical
                            Studios. We shipped Dungeonland and we hit Top 3 on
                            Steam selling list.
                        </Typography>
                        <br />

                        <Typography>Some of my tasks were:</Typography>

                        <List>
                            {criticalTasks.map((t, i) => (
                                <ListItem key={`task-${i}`}>
                                    <ListItemText>&bull; {t}</ListItemText>
                                </ListItem>
                            ))}
                        </List>
                        <br />

                        <Typography>
                            We also built two prototypes:{' '}
                            <Link href='https://store.steampowered.com/app/488960/Star_Vikings_Forever/'>
                                Star Vikings Forever
                            </Link>{' '}
                            (released by Critical's former game designer,{' '}
                            <Link href='https://roguesnail.com/'>
                                Mark Venturelli
                            </Link>
                            ) and another one that unfortunately will never see
                            the light of the day.
                        </Typography>

                        <Typography>
                            For all of them we used Unity3D with C#.
                        </Typography>
                    </Grid>
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                    id='indie'
                >
                    <Grid item xs={12}>
                        <Typography variant='h2' component='h2'>
                            Indie all the Way (kinda)
                        </Typography>
                    </Grid>
                    <Grid item xs={12} sm={10}>
                        <Typography>
                            After Critical Studio closing down, I had to take a
                            job in a big corporate engineering company and go
                            back to web development. It was hard to stop working
                            with games daily, so I've decided to save enough
                            money to take a sabbatical year.
                        </Typography>
                        <br />
                        <Typography>
                            One and a half years later I quit and decided to do
                            my own stuff, my own way, while getting some
                            freelance web jobs. I've created the following
                            personal games:
                        </Typography>
                    </Grid>

                    <Grid item xs={12} className={classes.textAlignCenter}>
                        <iframe
                            title='Darkness! Flashes!'
                            src='https://itch.io/embed/33273'
                            height='167'
                            width='552'
                            frameBorder='0'
                        >
                            <a href='https://diegomachado.itch.io/darkness-flashes'>
                                Darkness! Flashes! by diegomachado
                            </a>
                        </iframe>
                    </Grid>

                    <Grid item xs={12} className={classes.textAlignCenter}>
                        <iframe
                            title='Le Chef Farteaut'
                            src='https://itch.io/embed/57366'
                            height='167'
                            width='552'
                            frameBorder='0'
                        >
                            <a href='https://diegomachado.itch.io/le-chef-farteaut'>
                                Le Chef Farteaut by diegomachado
                            </a>
                        </iframe>
                    </Grid>

                    <Grid item xs={12} className={classes.textAlignCenter}>
                        <iframe
                            title='Basebrawl!'
                            src='https://itch.io/embed/57370'
                            height='167'
                            width='552'
                            frameBorder='0'
                        >
                            <a href='https://diegomachado.itch.io/basebrawl'>
                                Basebrawl! by diegomachado
                            </a>
                        </iframe>
                    </Grid>

                    <Grid item xs={12} md={10}>
                        <Typography>
                            Unfortunately Flash is no longer supported, but you
                            can read my{' '}
                            <Link href='http://ludumdare.com/compo/2015/04/22/le-chef-farteaut-postmortem/'>
                                Le Chef Farteaut’s
                            </Link>{' '}
                            and{' '}
                            <Link href='http://ludumdare.com/compo/2015/03/30/basebrawl/'>
                                BaseBrawl's
                            </Link>{' '}
                            postmortens if you wish.
                        </Typography>
                    </Grid>
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    direction='column'
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} id='gazeus'>
                        <Hidden xsDown>
                            <img src={gazeusLogo} alt='Gazeus Logo' />
                        </Hidden>
                        <Typography variant='h2' component='h2'>
                            Working at Gazeus Games
                        </Typography>
                        <Hidden xsDown>
                            <img src={gazeusLogo} alt='Gazeus Logo' />
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Typography>
                            After 1.5 years, my financial reserve was gone. It
                            was time to look for a job, so a close friend
                            recommended me to work at{' '}
                            <Link href='http://www.gazeus.com'>
                                Gazeus Games
                            </Link>
                            , a big mobile game studio here in Rio de Janeiro,
                            specialized on what we called Classic Social games.
                        </Typography>
                        <br />
                        <Typography>
                            Board, dice and card games to play together with
                            your friends such as Dominoes, Yatzy, Solitaire,
                            Mahjong and others alike. I've mostly worked on
                            Dominoes and Yatzy Party.
                        </Typography>
                        <br />
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    <Grid
                        item
                        xs={12}
                        md={6}
                        className={classes.textAlignCenter}
                    >
                        <iframe
                            title='Dominoes Trailer'
                            width='560'
                            height='315'
                            src='https://www.youtube.com/embed/j8YTtHN4eOw'
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                            allowFullScreen
                        ></iframe>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        lg={6}
                        className={classes.textAlignCenter}
                    >
                        <iframe
                            title='Yatzy Party Trailer'
                            width='560'
                            height='315'
                            src='https://www.youtube.com/embed/FbuE5SZvZ6E'
                            frameBorder='0'
                            allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
                            allowFullScreen
                        ></iframe>
                    </Grid>
                    <Grid item xs={12} lg={10}>
                        <Typography>
                            Working on Yatzy Party was definitely the most
                            interesting part. Half of our team was from Canada,
                            so we worked for almost 2 years remotely. Working
                            with them was really important for my communication
                            skills. We also had the opportunity to spend a whole
                            month in Montreal and it was one of the best
                            experiences in my personal and professional life.
                        </Typography>
                    </Grid>
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} id='solo'>
                        <Typography variant='h2' component='h2'>
                            Going Solo again
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Typography>
                            After 4 years working at Gazeus, that itch to
                            develop my own ideas came back. Spending lots of
                            time implementing Meta Game features, third-party
                            libraries, integrating Ad Networks, Analytics and
                            also helped with that. Besides having the greatest
                            team I could ever ask for, making those kinds of
                            games was not fulfilling me anymore. I had to put my
                            own ideas out into the world.
                        </Typography>
                        <Typography>
                            The way I found to minimize risks and take advantage
                            of my skills was to take a shot at the Hypercasual
                            Mobile market. This year, besides a big web
                            freelance job, I've managed to develop 7 games,
                            highlighting the following:
                        </Typography>
                        <br />
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    {hypercasualsVideos.map((h, i) => (
                        <Grid item xs={12} sm={6} key={`hyper-casual-${i}`}>
                            <iframe
                                title={h.title}
                                src={h.src}
                                allow='autoplay'
                                className={classes.iframe}
                            ></iframe>
                        </Grid>
                    ))}
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} md={10} id='ustwo'>
                        <Hidden xsDown>
                            <img src={ustwoLogo} alt='ustwo Logo' />
                        </Hidden>
                        <Typography variant='h2' component='h2'>
                            Working at ustwo
                        </Typography>
                        <Hidden xsDown>
                            <img src={ustwoLogo} alt='ustwo Logo' />
                        </Hidden>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Typography>
                            Through all my game development journey, I've never
                            stopped creating my own ideas. Projects with no
                            financial expectations, projects that I just wanted
                            to see existing in the world:
                        </Typography>
                    </Grid>
                </Grid>
            </Project>

            <div style={{ textAlign: 'center' }}>
                <iframe
                    title='Indie Games'
                    src='https://docs.google.com/presentation/d/e/2PACX-1vRNkt3RZmaRp7J14gFKP3mKfKfXVTRUIGGx2NjDmqay8wgev7snMDPa2xPiLZ3y2hVo6w0r8nYIluvI/embed?start=false&loop=true&delayms=3000'
                    frameBorder='0'
                    width='1440'
                    height='839'
                    allowFullScreen
                    className={classes.ppt}
                ></iframe>
            </div>

            <Project>
                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} md={10}>
                        <Typography>
                            Working with you would be the perfect balance
                            between those extremes of my career. It’s an
                            opportunity to develop meaningful projects and give
                            voice to my ideas while working in a healthy studio
                            with people who believe that work-life balance is
                            essential for our well being.
                        </Typography>
                        <br />
                        <Typography>
                            I’m confident that I’m a great fit for what ustwo
                            needs:
                        </Typography>
                        <List>
                            <List>
                                {usTwoReasons.map((t, i) => (
                                    <ListItem key={`task-${i}`}>
                                        <ListItemText>&bull; {t}</ListItemText>
                                    </ListItem>
                                ))}
                            </List>
                        </List>
                    </Grid>
                </Grid>

                <div className='session-divider'>...</div>

                <Grid
                    container
                    spacing={3}
                    justify='center'
                    alignItems='center'
                >
                    <Grid item xs={12} md={10}>
                        <Typography
                            variant='h2'
                            component='h2'
                            style={{ color: '#e81224' }}
                        >
                            &#10084;&#10084;&#10084;
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={10}>
                        <Typography>
                            Thank you for this opportunity and thank you for
                            reading my career story! I hope it was nice to read
                            as it was nice to prepare this for you. I'm looking
                            forward for your feedback. Have a good one!
                        </Typography>
                    </Grid>
                </Grid>
            </Project>
        </div>
    );
};

export default CoverLetter;
